import React from 'react';
import { Heading } from '../../../../components/Typography/Typography';
import CreateBenchmarkQuestion from './CreateBenchmarkQuestion';
import RunBenchmarkEvaluations from './RunBenchmarkEvaluations';
import styles from '../BenchmarkQuestionsPage.module.scss';

interface BenchmarkHeaderProps {
  loading: boolean;
  setError: (error: string | null) => void;
  onQuestionCreated: () => void;
}

const BenchmarkHeader: React.FC<BenchmarkHeaderProps> = ({
  loading,
  setError,
  onQuestionCreated,
}) => {
  return (
    <div className={styles.header}>
      <Heading level={1}>Benchmark Questions</Heading>
      <div className={styles.headerButtons}>
        <CreateBenchmarkQuestion onQuestionCreated={onQuestionCreated} />
        <RunBenchmarkEvaluations loading={loading} setError={setError} />
      </div>
    </div>
  );
};

export default BenchmarkHeader;
